import { connect } from "react-redux";
import { DetailsSubHeader } from "../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { type RootState } from "../../../Application/globaltypes/redux";

const mapStateToProps = (state: RootState, ownProps: DetailsSubHeaderProps & { showLastModified: boolean }) => {
  const embeddedVideo = state.library.embeddedVideos;
  return {
    isUpdateInProgress: embeddedVideo.entitState.isEntityCommandInProgress && ownProps.isUpdateInProgress,
    lastModifiedDateTime: ownProps.showLastModified
      ? embeddedVideo.entitState.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
      : undefined,
  };
};

export default connect(mapStateToProps)(DetailsSubHeader);
